import { Outlet } from "react-router-dom";

import SideBar from "../../components/Dashboard/SideBaer";
import TopBar from "../../components/Dashboard/TopBar";
import './dashboard.css';

export default function Dashboard ()
{
    return (
        <div className="position-relative">
            <TopBar />
            <div className="dashboard d-flex gap-2">
                <SideBar />
                <div className="flex-grow-1">
                    <Outlet />
                </div>
            </div>
        </div>
    );
}
